import React from 'react';

import { State } from '@hookstate/core';

import { useQuery } from 'react-query';
import {
  IEquipmentStatus,
  IEquipmentStatusApiModel,
} from '@models/EquipmentStatus.model';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { indexEquipmentStatus } from '@services/queries/equipmentStatus';
import { beam } from '@styles/colors/themes';
import {
  Container,
  Label,
  Header,
  CloseButton,
  IconChevRightAwesome,
  Circle,
  RowDiv,
  LineDiv,
  TextButton,
  TextBlue,
} from './ChangeEquipmentStatus.styles';

interface IAddFieldContent {
  openAddField: State<boolean>;
  actualStatus: Pick<IEquipmentStatus, 'name' | 'id'> | undefined;

  onClickStatus: (input: IEquipmentStatusApiModel) => void;
}

const ChangeEquipmentStatus = ({
  openAddField,
  actualStatus,
  onClickStatus,
}: IAddFieldContent) => {
  const { data } = useQuery('equipmentStatus', indexEquipmentStatus);

  return (
    <Container>
      <Header>
        Select a status
        <CloseButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          <IconChevRightAwesome icon={faChevronDown} />
        </CloseButton>
      </Header>
      <Label>Online</Label>
      {data
        ?.filter(status => status.category === 'Online')
        .map(item => {
          return (
            <LineDiv key={item.id}>
              <RowDiv
                onClick={() => {
                  onClickStatus(item);
                  openAddField.set(false);
                }}
              >
                <Circle color={beam.status.online} />
                <TextButton>{item.name}</TextButton>
              </RowDiv>
              {item.name === actualStatus?.name && (
                <TextBlue>Selected</TextBlue>
              )}
            </LineDiv>
          );
        })}
      <Label>Offline</Label>
      {data
        ?.filter(status => status.category === 'Offline')
        .map(item => {
          return (
            <LineDiv key={item.id}>
              <RowDiv
                onClick={() => {
                  onClickStatus(item);
                  openAddField.set(false);
                }}
              >
                <Circle color={beam.status.offline} />
                <TextButton>{item.name}</TextButton>
              </RowDiv>
              {item.name === actualStatus?.name && (
                <TextBlue>Selected</TextBlue>
              )}
            </LineDiv>
          );
        })}
      <Label>Decommissioned</Label>
      {data
        ?.filter(status => status.category === 'Decommissioned')
        .map(item => {
          return (
            <LineDiv key={item.id}>
              <RowDiv
                onClick={() => {
                  onClickStatus(item);
                  openAddField.set(false);
                }}
              >
                <Circle color={beam.status.decommissioned} />
                <TextButton>{item.name}</TextButton>
              </RowDiv>
              {item.name === actualStatus?.name && (
                <TextBlue>Selected</TextBlue>
              )}
            </LineDiv>
          );
        })}
    </Container>
  );
};

export { ChangeEquipmentStatus };
